// import React from "react";

// import Searchbar from "../../utils/searchbar/Searchbar";
// import SearchReviewers from "../../search/SearchReviewers";

// class ReviewersSearch extends React.PureComponent {
// 	render() {
// 		return (
// 			<React.Fragment>
// 				<Searchbar
// 					placeholder={"Search reviewers"}
// 					component={SearchReviewers}
// 					searchEndpoint={"search/reviewers"}
// 					basePath={this.props.location.pathname + "/edit"}
// 					{...this.props}
// 					userType="admin"
// 				/>
// 			</React.Fragment>
// 		);
// 	}
// }

// export default ReviewersSearch;

import React from 'react'
import DataTable from '../../utils/DataTable/DataTable';
import moment from 'moment-timezone';

const columnData = [
	{ 
		label: 'Color', 
		key: 'color',
		transform (input) {
			return `<div class="color-dot color-${input}"></div>`
		}
	},
	{ 
		label: 'Full Name', 
		key: 'name'
	},
	{ 
		label: 'Email', 
		key: 'email' 
	},
	{ 
		label: 'Joined', 
		key: 'date_added',
		transform (input) {
			return moment(input).format('MMM Do YYYY')
		}
	},
	{ 
		label: 'Last Updated', 
		key: 'date_edited' ,
		transform (input) {
			return moment(input).format('MMM Do YYYY [|] h:mm a')
		}
	},
	{ 
		label: 'Type', 
		key: 'account_accepted_text'
	},
	{ 
		label: 'Status', 
		key: 'status_text'
	}
];

const ReviewersSearch = ({ location }) => {
	return (
		<DataTable 
			apiEndpoint={'data-search/reviewers'}
			columns={columnData}
			editRoute={location.pathname + '/edit/'}
			defaultColumnSort='date_edited'
		/>
	)
}

export default ReviewersSearch;


// WEBPACK FOOTER //
// ./src/components/admin/reviewers/ReviewersSearch.js